export const DEFAULT_PHOTO_ALBUM_PHOTO_COUNT = 40;
export const ALBUM_GENERATION_TIME_MINUTES = 15;
export const MODEL_TRAINING_TIME_MINUTES = 5;
export const MAX_TRAINING_IMAGES = 8;
